import { Route } from "react-router";
import Layout from "./components/layout/Layout";
import SocialLogin from "./pages/SocialLogin";
import SocialLoginConsent from "./pages/SocialLoginConsent";
import ConsentScreen from "./pages/shared/consent/ConsentAuthorizationScreenPage";
import ConsentDeclineConfirmation from "./pages/shared/consent/ConsentDeclineConfirmationPage";

export default function SocialLoginApp() {
  return (
    <Layout className="self-center max-w-[40ch] w-full px-8 mx-auto">
      <Route path="/SocialLogin" component={SocialLogin} />
      <Route path="/SocialLoginConsent" component={SocialLoginConsent} />
      <Route path="/AuthorizeConsent" component={ConsentScreen} />
      <Route path="/AuthorizeConsentDecline" component={ConsentDeclineConfirmation} />
    </Layout>
  );
}
